// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDR2-zYcQWnnQjUS7bHAaY_WxADhiKqEoA",
  authDomain: "ahsanali-web.firebaseapp.com",
  databaseURL: "https://ahsanali-web-default-rtdb.firebaseio.com",
  projectId: "ahsanali-web",
  storageBucket: "ahsanali-web.firebasestorage.app",
  messagingSenderId: "539591764522",
  appId: "1:539591764522:web:aba4977b6e7868a9397153",
  measurementId: "G-D15N7RQCN0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

export { app, auth, functions, db };
export const storage = getStorage();
